const workflowInstance = {
  id: null,
  workflowTemplateId: null,
  dealId: null,
  assignmentId: null,
  directPlacementId: null,
  adminUserId: null,
  statusId: null,
  createdAt: null,
  updatedAt: null,
  createdBy: null,
  updatedBy: null,
  templateName: null,
  statusName: null,
  adminUserName: null,
  candidateName: null,
  clientName: null,
  targetStartDate: null,
  progressPercentage: 0,
  tasks: []
}

export default () => Object.assign({}, workflowInstance, { tasks: [] })
